<template>
  <div>
    <div class="fixed-row">
      <!--	PC-返回地图	-->
      <div
        v-if="!isMobile && isFromIndexMap"
        class="back-map"
        @click="$router.go(-1)"
      >
        <i class="el-icon-arrow-left"></i>返回地图
      </div>
      <div class="views">人气：{{ worksDetail.views }}</div>
    </div>
    <div v-if="isMobile" class="fix-btn-mobile">
      <!--	返回地图	-->
      <div
        v-if="isFromIndexMap"
        class="item item-back"
        @click="$router.go(-1)"
      ></div>
      <div
        v-if="isWx && worksDetail.info && worksDetail.info.appId"
        class="item item-ticket"
      >
        <wx-open-launch-weapp
          id="launch-btn"
          :username="worksDetail.info.appId"
          :path="worksDetail.info.path"
        >
          <script type="text/wxtag-template">
            <style>.btn {width:100%;height:100%;opacity:0; }</style>
             <button class="btn">打开小程序</button>
          </script>
        </wx-open-launch-weapp>
      </div>
      <div
        class="item item-giveup"
        :class="{ active: isGiveUp }"
        @click="giveUp"
      ></div>
      <div class="item item-comment" @click="isShowComment = true"></div>
      <div
        v-if="sceneList.length > 1"
        class="item item-category"
        @click="mutationUpDateSceneBar(!isShowSceneBar)"
      ></div>
      <div v-if="sceneData && sceneData.describe" class="item item-intro" @click="isShowMIntro = !isShowMIntro"></div>
      <!--	Mobile-Wx-导航	-->
      <div v-if="isWx" class="item item-navigation" @click="openLocation"></div>
      <!--  联系 -->
<!--      <div v-if="websiteInfo.isContact && !isSplitScreen" class="item item-contact"  @click="isShowContactMobile = !isShowContactMobile"></div>-->
      <!--  分屏 -->
      <div v-if="groupList.length > 1" class="item item-split" @click="splitScreen"></div>
      <!--  位置   -->
<!--      <div v-if="isShowFilterPosition" class="item item-position" @click="isShowPosition = !isShowPosition"></div>-->
    </div>

    <div v-if="!isMobile" class="fixed-box">
      <div class="fixed-item" :class="{ active: isGiveUp }" @click="giveUp">
        <i v-if="isGiveUp" class="icon iconfont icon-give-up-solid"></i>
        <i v-else class="icon iconfont icon-give-up"></i>
        <div class="label">点赞({{ worksDetail.praise }})</div>
      </div>
      <div class="fixed-item" @click="isShowComment = true">
        <i class="icon iconfont icon-comment"></i>
        <div class="label">评论({{ commentListTotal }})</div>
      </div>
      <div v-if="sceneList.length > 1" class="fixed-item" @click="mutationUpDateSceneBar(!isShowSceneBar)">
        <i class="icon iconfont icon-category"></i>
        <div class="label">导航</div>
      </div>
      <div v-if="sceneData && sceneData.describe" class="fixed-item" @click="mutationUpDateShowIntro(!isShowIntro)">
        <i class="icon iconfont icon-file"></i>
        <div class="label">详情</div>
      </div>
      <div v-if="groupList.length > 1" class="fixed-item" @click="splitScreen">
        <i class="icon iconfont icon-split"></i>
        <div class="label">分屏</div>
      </div>
      <div class="fixed-item" title="显示/隐藏覆盖物" @click="toggleHotspot">
        <i class="icon iconfont" :class="isShowHotspot ? 'icon-view' : 'icon-view-disabled'"></i>
        <div v-if="isShowHotspot" class="label">显示热点</div>
        <div v-else class="label">隐藏热点</div>
      </div>
      <div class="fixed-item" @click="krp.call('makeScreenshot()')">
        <i class="icon iconfont icon-camera"></i>
        <div class="label">截屏</div>
      </div>
<!--      <div v-if="isShowFilterPosition" class="fixed-item" @click="isShowPosition = !isShowPosition">-->
<!--        <i class="icon iconfont icon-position"></i>-->
<!--        <div class="label">{{isShowPosition ? '显示' : '隐藏'}}位置</div>-->
<!--      </div>-->
<!--      <div v-if="websiteInfo.isContact" class="fixed-item" @click="isShowContact = true">-->
<!--        <i class="icon el-icon-s-custom"></i>-->
<!--        <div class="label">联系</div>-->
<!--      </div>-->
    </div>

    <!--   退出分屏 -->
    <div v-if='isSplitScreen' class="btn-exit-split" :class="{floor:!isShowSceneBar,mobile:isMobile}" @click="splitScreen">退出分屏</div>
    <!--   评论内容 -->
    <fix-side-comment v-if="isShowComment" :show.sync="isShowComment" />
    <!--   简介内容 -->
    <fix-side-intro :show.sync="isShowMIntro" />
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import GPS from '../gps'
import fixSideComment from "./fix-side-comment.vue";
import fixSideIntro from "./fix-side-intro";
import Vue from "vue";
Vue.config.ignoredElements = ["wx-open-launch-weapp"];
export default {
  components: { fixSideComment, fixSideIntro },
  data() {
    return {
      isShowComment: false,
      isGiveUp: false,
      worksId: this.$route.query.id,
      giveUpNumber: 0,
      isShowMIntro: false, //手机端-简介
			isShowPosition:true,
			isShowHotspot:true
    };
  },
  computed: {
    ...mapState("preview", [
      "krp",
      "materialId",
      "isShowSceneBar",
      "isShowIntro",
      "isFromIndexMap",
      "worksDetail",
      "commentListTotal",
      "groupList",
      "isSplitScreen",
      "activeGroupId",
      "sceneList"
    ]),
    sceneData() {
      let sceneList = this.sceneList;
      return Array.isArray(sceneList)
        ? sceneList.find((item) => this.materialId == item.id)
        : {};
    },
    isWx() {
      let ua = navigator.userAgent.toLowerCase();
      return ua.match(/MicroMessenger/i) == "micromessenger";
    },
		websiteInfo() {
			return this.$store.state.user.websiteInfo || {}
		},
    isShowFilterPosition(){
    	return this.sceneData && this.sceneData.extra && this.sceneData.extra.spotList.filter(item=>item.imageType == 5).length > 0
    }
  },

  watch:{
		isShowPosition(val){
			this.sceneData.extra.spotList.filter(item=>item.imageType == 5).forEach(item=>{
				this.krp.call(`set(hotspot[hotsport_${item.id}].visible,${val})`);
				this.krp.call(`set(hotspot[hotsport_${item.id}_placeholder].visible,${val})`);
				this.krp.call(`set(layer[hotsport_${item.id}_title].visible,${val})`);
			})
    }
  },

  async created() {
    this.init();
    await this.actionGetCommentList({ worksId: this.worksId });
  },
  methods: {
    ...mapMutations("preview", {
      mutationUpDateSceneBar: "UPDATE_SCENE_BAR",
      mutationUpDateShowIntro: "UPDATE_SHOW_INTRO",
			mutationUpdateIsSplitScreen: "UPDATE_IS_SPLIT_SCREEN"
    }),
    ...mapActions("preview", {
      actionGetCommentList: "getCommentList",
			activeGetWorksDetail: "getWorksDetail",
    }),

    init() {
      let giveUpData = localStorage.getItem("v-works");
      giveUpData = giveUpData ? JSON.parse(giveUpData) : {};
      this.isGiveUp =
        giveUpData[this.worksId] && giveUpData[this.worksId].isGiveUp;
    },
    async giveUp() {
      if (this.isGiveUp) {
        return;
      }
      try {
        await this.api.works.praise({ worksId: this.worksId });
        let giveUpData = localStorage.getItem("v-works");
        giveUpData = giveUpData ? JSON.parse(giveUpData) : {};
        if (giveUpData[this.worksId]) {
          giveUpData[this.worksId].isGiveUp = true;
        } else {
          giveUpData[this.worksId] = { isGiveUp: true };
        }
        localStorage.setItem("v-works", JSON.stringify(giveUpData));
        this.isGiveUp = true;
        this.worksDetail.praise++;
      } catch (e) {
        console.error(e);
      }
    },

    async openLocation() {
      /* global wx */
      if (!this.worksDetail.lat) {
        return;
      }
      let BD09 = {lat: this.worksDetail.lat,lng: this.worksDetail.lng};
      let GCJ02 = GPS.bd_decrypt(BD09.lat,BD09.lng);
      //let WGS84 = GPS.gcj_decrypt(GCJ02.lat,GCJ02.lon);

      wx.openLocation({
        latitude: Number(GCJ02.lat),
        longitude: Number(GCJ02.lon),
        name: this.worksDetail.name,
        address: "点击右侧导航按钮选择导航方式",
        scale: 15,
      });
    },

		async splitScreen(){
    	if(this.isSplitScreen){
				removepano(this.krp.get('syncviewer'));
      }
			this.mutationUpdateIsSplitScreen(!this.isSplitScreen);
    },

		//显示隐藏热点
		toggleHotspot() {
			this.isShowHotspot = !this.isShowHotspot;
			if (this.isShowHotspot) {
				this.krp.call('show_hotspot()');
				this.userPolylineList.forEach((item) => {
					this.krp.call(`set(hotspot[${item.name}_delete].visible,${item.is_own == 1})`);
				});
			} else {
				this.krp.call('hide_hotspot()');
			}
		},


  },
};
</script>

<style scoped>
.fixed-row {
  position: fixed;
  top: 0;
  right: 10px;
  height: 50px;
  color: #fff;
  display: flex;
  align-items: center;
}
.fixed-row .views{
  text-shadow: 1px 1px #999;
}
.back-map {
  background: #43897b;
  color: #fecf7c;
  padding: 0 15px;
  border-radius: 20px;
  cursor: pointer;
  font-weight: bold;
  height: 30px;
  display: flex;
  align-items: center;
  margin-right: 10px;
}

.back-map i {
  font-weight: bold;
  margin-right: 5px;
  color: #fecf7c;
}
.fixed-box {
  position: fixed;
  right: 10px;
  top: 50px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.fixed-box .fixed-item {
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 40px;
}

.fixed-box .fixed-item .icon {
  width: 34px;
  height: 34px;
  cursor: pointer;
  margin-bottom: 5px;
  background: rgba(0, 0, 0, 0.3);
  color: #fff;
  border: 1px solid #9d9993;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  opacity: 0.8;
}

.fixed-box .fixed-item .label {
  font-size: 12px;
  color: #fff;
  cursor: pointer;
  white-space: nowrap;
}
.fixed-item.active .icon {
  border-color: #4e81ff;
  color: #4e81ff;
}

.fix-btn-mobile {
  position: absolute;
  right: 0;
  top: 40px;
  z-index: 1000;
}

.fix-btn-mobile .item {
  cursor: pointer;
  color: #55877c;
  width: 50px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.fix-btn-mobile .item-back {
  background: url("../../../assets/images/vm-icon-back.png") center center
    no-repeat;
  background-size: 18px auto;
}

.fix-btn-mobile .item-navigation {
  background: url("../../../assets/images/vm-icon-navigation.png") center center
    no-repeat;
  background-size: 18px auto;
}

.fix-btn-mobile .item-intro {
  background: url("../../../assets/images/vm-icon-file.png") center center
    no-repeat;
  background-size: 16px auto;
}
.fix-btn-mobile .item-contact {
  background: url("../../../assets/images/vm-icon-user.png") center center
  no-repeat;
  background-size: 20px auto;
  position: fixed;
  right: 0;
  bottom: 160px;
}
.fix-btn-mobile .item-giveup {
  background: url("../../../assets/images/vm-icon-up.png") center center
    no-repeat;
  background-size: 18px auto;
}
.fix-btn-mobile .item-giveup.active {
  background: url("../../../assets/images/vm-icon-up-solid.png") center center
    no-repeat;
  background-size: 18px auto;
}
.fix-btn-mobile .item-comment {
  background: url("../../../assets/images/vm-icon-comment.png") center center
    no-repeat;
  background-size: 18px auto;
}
.fix-btn-mobile .item-category {
  background: url("../../../assets/images/vm-icon-category.png") center center
    no-repeat;
  background-size: 18px auto;
}
.fix-btn-mobile .item-ticket {
  background: url("../../../assets/images/vm-icon-ticket.png") center center
    no-repeat;
  background-size: 20px auto;
}

.fix-btn-mobile .item-split {
  background: url("../../../assets/images/vm-icon-split.png") center center no-repeat;
  background-size: 20px auto;
}

.fix-btn-mobile .item-position {
  background: url("../../../assets/images/position.png") center center
  no-repeat;
  background-size: 16px auto;
}

.btn-exit-split {
  position: absolute;
  width: 100px;
  height: 30px;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 50%;
  transform: translateX(-50%);
  bottom: 110px;
}

.btn-exit-split.floor,.btn-exit-split.mobile {
  bottom: 10px;
}
</style>
